import { preflightApiClient } from '../api/client';

export type FeedbackSection =
  | 'HOME_PAGE_DEFAULT'
  | 'PAYMENT_PAGE_DEFAULT'
  | 'RESULT_PAGE_DEFAULT'
  | 'RESULT_PAGE_SUMMARY_REPORT'
  | 'RESULT_PAGE_DETAILED_REPORT';

export type FeedbackRating =
  | 'OUTSTANDING'
  | 'ACCEPTABLE'
  | 'NOT_ACCEPTABLE'
  | 'NO_RATING';

export type TargetedFeedbackItem = {
  label: string;
  comment: string;
};

export type SubmitFeedbackPayload = {
  documentId: string;
  section?: FeedbackSection;
  rating: FeedbackRating;
  comment?: string;
  email?: string;
  wantsEmailUpdates?: boolean;
  targetedFeedback?: TargetedFeedbackItem[];
};

export async function checkFeedbackExists(
  documentId: string,
  section: FeedbackSection,
): Promise<boolean> {
  try {
    const response = await preflightApiClient.get(
      `/${documentId}/feedback-exist?section=${section}`,
    );
    return Boolean(response);
  } catch (error) {
    return false;
  }
}

export async function submitFeedback(
  payload: SubmitFeedbackPayload,
): Promise<void> {
  try {
    await preflightApiClient.post('/submit-feedback', payload);
  } catch (error) {
    console.error('Error submitting feedback:', error);
    throw error;
  }
}

export async function requestFollowUp({
  documentId,
  email,
}: {
  documentId: string;
  email?: string;
}): Promise<void> {
  try {
    const endpoint = `/${documentId}/request-follow-up`;
    const url = email
      ? `${endpoint}?email=${encodeURIComponent(email)}`
      : endpoint;

    await preflightApiClient.post(url, {});
  } catch (error) {
    console.error('Error requesting follow-up:', error);
    throw error;
  }
}
